import { useFontReferences } from "./useFontReferences";

export const useFontReferencesCount = (fontId: string) => {
  const { data: colorCollectionReferences } = useFontReferences(fontId);

  const totalFontCollections =
    colorCollectionReferences?.alphabet_collection_list?.length || 0;

  return { total: totalFontCollections };
};
